document.addEventListener("DOMContentLoaded", function() {
  var lazyImagesBG = [].slice.call(document.querySelectorAll(".lazy-bg"));
  
  
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          // lazyImage.addClass('test');
          lazyImage.style.backgroundImage = 'url('+ lazyImage.dataset.background +')';
          lazyImage.src = lazyImage.dataset.background;
          lazyImage.srcset = lazyImage.dataset.backgroundset;
          lazyImage.classList.remove("lazy-bg");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    // lazyImages.forEach(function(lazyImage) {
    //   lazyImageObserver.observe(lazyImage);
    // });
    	$(lazyImagesBG).each(function(index, lazyImage) {
        //console.log(lazyImage);
      	lazyImageObserver.observe(lazyImage);
    	});
    
    // console.log('observer');
    
  } else {
    
    lazyImagesBG.forEach(image => {
        handleImageBG(image);
    })
    
    
  }
                                                      
});

function handleImageBG(el) {
    preloadImage(el.dataset.background).then(src => {
      
        if(el.classList.contains("lazy-bg")){
          el.style.backgroundImage = 'url('+ src +')'
        } else {
          el.src = src ;
        }
            
        // el.classList.add('fade');
        el.removeAttribute('data-background');
    })    
}

function preloadImage(url) {
    return new Promise((resolve,reject) => {
        let image = new Image();
        image.load = resolve(url);
        image.error = reject;
        image.src = url;
    })
}